import React from 'react';
import Modal from '../../../../components/Modal';
import DropDown from '../../../../components/DropDown';
import { useEditDetails } from './EditDetailsData';
import {
    ENTITY_TYPE_OPTIONS,
    ENTITY_LOB_TYPE_OPTIONS,
    LOB_NATIONALITY_OPTIONS,
} from '../../../../constants/formOptions';
import './index.scss';

const EditClientModal = ({ isOpen, onClose, clientData, onSave }) => {
    const {
        formData: entity,
        isSubmitting,
        handleChange,
        handleSubmit,
        handleClose,
        getDocumentStatusBadge,
    } = useEditDetails(clientData, onSave, onClose);

    if (!clientData) return null;

    const documents = clientData.documents || [];

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleClose}
            title="Edit Entity"
            size="large"
        >
            <form onSubmit={handleSubmit} className="edit-entity-form">
                <div className="form-content">
                    {/* Entity Information Section */}
                    <div className="form-section">
                        <h3 className="section-title">Entity Information</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Entity ID</label>
                                <input
                                    type="text"
                                    value={entity.entityId || ""}
                                    disabled
                                    className="disabled-field"
                                />
                            </div>
                            <div className="form-group">
                                <label>Entity Category</label>
                                <input
                                    type="text"
                                    value={entity.entityCategory || ""}
                                    disabled
                                    className="disabled-field"
                                />
                            </div>
                            <div className="form-group full-width">
                                <label>Entity Name <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="entityName"
                                    value={entity.entityName || ""}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group full-width">
                                <label>Entity Address <span className="required">*</span></label>
                                <textarea
                                    name="entityAddress"
                                    value={entity.entityAddress || ""}
                                    onChange={handleChange}
                                    rows="2"
                                    required
                                />
                            </div>
                            {/* <div className="form-group">
                                <DropDown
                                    name="entityType"
                                    value={entity.entityType || ""}
                                    onChange={handleChange}
                                    label="Entity Type"
                                    placeholder="Select Entity Type"
                                    options={ENTITY_TYPE_OPTIONS}
                                    fullWidth
                                />
                            </div> */}
                            <div className="form-group">
                                <DropDown
                                    name="lobType"
                                    value={entity.lobType || ""}
                                    onChange={handleChange}
                                    label="LOB Type"
                                    placeholder="Select LOB Type"
                                    options={ENTITY_LOB_TYPE_OPTIONS}
                                    fullWidth
                                />
                            </div>
                            <div className="form-group">
                                <DropDown
                                    name="lobNationality"
                                    value={entity.lobNationality || ""}
                                    onChange={handleChange}
                                    label="LOB Nationality"
                                    placeholder="Select Nationality"
                                    options={LOB_NATIONALITY_OPTIONS}
                                    fullWidth
                                />
                            </div>
                        </div>
                    </div>

                    {/* Business Details Section */}
                    <div className="form-section">
                        <h3 className="section-title">Business Details</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>AA Department/Function</label>
                                <input
                                    type="text"
                                    name="aaDepartmentFunction"
                                    value={entity.aaDepartmentFunction || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Nature of Business</label>
                                <input
                                    type="text"
                                    name="natureOfBusiness"
                                    value={entity.natureOfBusiness || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>PAN Number</label>
                                <input
                                    type="text"
                                    name="panNumber"
                                    value={entity.panNumber || ""}
                                    onChange={handleChange}
                                    maxLength="10"
                                />
                            </div>
                            <div className="form-group checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="isGSTRegistered"
                                        checked={entity.isGSTRegistered || false}
                                        onChange={handleChange}
                                    />
                                    <span>GST Registered</span>
                                </label>
                            </div>
                            {entity.isGSTRegistered && (
                                <>
                                    <div className="form-group">
                                        <label>GST Number</label>
                                        <input
                                            type="text"
                                            name="gstNumber"
                                            value={entity.gstNumber || ""}
                                            onChange={handleChange}
                                            maxLength="15"
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label>Other GST Numbers</label>
                                        <input
                                            type="text"
                                            name="otherGSTNumbers"
                                            value={entity.otherGSTNumbers || ""}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            )}
                            <div className="form-group checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="isRegisteredUnderMSME"
                                        checked={entity.isRegisteredUnderMSME || false}
                                        onChange={handleChange}
                                    />
                                    <span>MSME Registered</span>
                                </label>
                            </div>
                        </div>
                    </div>

                    {/* Contact Details Section */}
                    <div className="form-section">
                        <h3 className="section-title">Contact Details</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Contact Person <span className="required">*</span></label>
                                <input
                                    type="text"
                                    name="contactPerson"
                                    value={entity.contactPerson || ""}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Designation</label>
                                <input
                                    type="text"
                                    name="designation"
                                    value={entity.designation || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Mobile Number <span className="required">*</span></label>
                                <input
                                    type="tel"
                                    name="mobileNumber"
                                    value={entity.mobileNumber || ""}
                                    onChange={handleChange}
                                    maxLength="10"
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label>Email Address <span className="required">*</span></label>
                                <input
                                    type="email"
                                    name="emailAddress"
                                    value={entity.emailAddress || ""}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>

                    {/* Bank Details Section */}
                    <div className="form-section">
                        <h3 className="section-title">Bank Details</h3>
                        <div className="form-grid">
                            <div className="form-group">
                                <label>Bank Name</label>
                                <input
                                    type="text"
                                    name="bankName"
                                    value={entity.bankName || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Branch Name & Address</label>
                                <input
                                    type="text"
                                    name="branchNameAndAddress"
                                    value={entity.branchNameAndAddress || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Account Type</label>
                                <input
                                    type="text"
                                    name="accountType"
                                    value={entity.accountType || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>Account Number</label>
                                <input
                                    type="text"
                                    name="accountNumber"
                                    value={entity.accountNumber || ""}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="form-group">
                                <label>IFSC Code</label>
                                <input
                                    type="text"
                                    name="ifscCode"
                                    value={entity.ifscCode || ""}
                                    onChange={handleChange}
                                    maxLength="11"
                                />
                            </div>
                            <div className="form-group checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="thirdPartyPayment"
                                        checked={entity.thirdPartyPayment || false}
                                        onChange={handleChange}
                                    />
                                    <span>Third Party Payment</span>
                                </label>
                            </div>
                            {entity.thirdPartyPayment && (
                                <div className="form-group full-width">
                                    <label>Relation with Beneficiary</label>
                                    <input
                                        type="text"
                                        name="relationWithBeneficiary"
                                        value={entity.relationWithBeneficiary || ""}
                                        onChange={handleChange}
                                    />
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Documents Section - Read Only */}
                    <div className="form-section">
                        <h3 className="section-title">Documents ({documents.length})</h3>
                        {documents.length === 0 ? (
                            <p className="no-documents">No documents available</p>
                        ) : (
                            <div className="documents-list">
                                {documents.map((doc, index) => (
                                    <div key={index} className="document-item">
                                        <div className="doc-info">
                                            <div className="doc-name">
                                                {doc.documentName}
                                                {doc.isMandatory && <span className="mandatory-badge">Required</span>}
                                            </div>
                                            {doc.isUploaded && doc.fileName && (
                                                <div className="doc-filename">{doc.fileName}</div>
                                            )}
                                        </div>
                                        <div className="doc-status-wrapper">
                                            {getDocumentStatusBadge(doc)}
                                            {doc.isUploaded && doc.filePath && (
                                                <a
                                                    href={doc.filePath}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="view-doc-btn"
                                                >
                                                    View
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="form-actions">
                    <button
                        type="button"
                        className="btn-cancel"
                        onClick={handleClose}
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="btn-submit"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Saving...' : 'Save Changes'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};

export default EditClientModal;
